export default __webpack_public_path__ + "static/media/grade_icons_hard.68baaf67.png";